import React from "react";
import appService from "../../../services/app.service";
import { DetailsOverview } from "../base/DetailsOverview";
import { useTranslation } from "react-i18next";
import { NoAdminAlert } from "../../NoAdminAlert"

export const EtlSolutionOverview: React.FunctionComponent<{ isAdmin: boolean }> = (props) => {
    const detailsRedirection = "/config/etlsolution/details";
    const {t}=useTranslation();

    const { isAdmin } = props;
    const title = t("client:headers:tabEtlSolution");

    if (isAdmin !== true) { return <NoAdminAlert /> }
    
    return (
        <DetailsOverview detailsRedirection={detailsRedirection} getItems={appService.getEtlSolutions} hasNumber={true}  entityType="etlsolutions" title={title}></DetailsOverview>
    );
};